import { addDays, isSameDay } from 'date-fns';

import { formatDate } from './format-date';

export function formatDatePast(date: Date) {
  const today = new Date();
  if (isSameDay(date, today)) {
    return 'today';
  }

  if (isSameDay(date, addDays(today, -1))) {
    return 'yesterday';
  }

  return formatDate(date);
}
